import Cookie from 'js-cookie';
import { t } from 'ttag';

// use owm isClientRendering function in oder to not allow import other modules before init i18n
function isClientRendering() {
    return typeof window !== 'undefined';
}

const LOCALE_COOKIE = '__locale';

export enum LOCALES {
    EN = 'en',
    UK = 'uk',
}

export function saveLocale(locale: LOCALES) {
    Cookie.set(LOCALE_COOKIE, locale);
}

export const getLocale = (): LOCALES => {
    if (isClientRendering()) {
        const cookieLocale = Cookie.get(LOCALE_COOKIE);
        const availableLocales = config.AVAILABLE_LANGUAGES;

        if (availableLocales.includes(cookieLocale as LOCALES)) {
            return cookieLocale as LOCALES;
        }

        return config.DEFAULT_LANGUAGE;
    }

    return config.DEFAULT_LANGUAGE;
};

export function changeLocale(locale: LOCALES) {
    saveLocale(locale);
    window.location.reload();
}

export const isEnglishLocale = () => getLocale() === LOCALES.EN;
export const isUkraineLocale = () => getLocale() === LOCALES.UK;

export function localizeSupportHours(customSupportHours?: string) {
    const supportHours = customSupportHours || config.SUPPORT_HOURS;

    return t`(пн-пт ${supportHours})`;
}
